var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { IntlProvider, useIntl } from "react-intl";
var translate = function (id, defaultMessage, args) {
    if (defaultMessage === void 0) { defaultMessage = null; }
    if (args === void 0) { args = {}; }
    var _a = useIntl(), messages = _a.messages, formatMessage = _a.formatMessage;
    var message = messages["".concat(id)];
    return (_jsx(React.Fragment, { children: messages["".concat(id)] ? formatMessage({ id: message.id, defaultMessage: message.defaultMessage }, args) : (defaultMessage ? null : "".concat(id, " not defined")) }));
};
var I18nProvider = function (props) {
    console.log(props.messages);
    return (_jsx(IntlProvider, __assign({ onError: function () { }, messages: props.messages, locale: props.locale || "en", defaultLocale: "en" }, { children: props.children }), props.locale || "en"));
};
export { I18nProvider, translate };
